import { render, staticRenderFns } from "./СMCourseCounts.vue?vue&type=template&id=19142b24&scoped=true&lang=pug&"
import script from "./СMCourseCounts.vue?vue&type=script&lang=js&"
export * from "./СMCourseCounts.vue?vue&type=script&lang=js&"
import style0 from "./СMCourseCounts.vue?vue&type=style&index=0&id=19142b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19142b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
